import React from "react";

import YouTube from "./ProfileCarouselcard"
import YouTube1 from "./ProfileCarouselcard1"





const ProfileCarousel = () => {
  return (
    <section className="">

        <YouTube/>
        {/* <YouTube1/> */}

    </section>
  );
};

export default ProfileCarousel;
